export const modal = () => {
  // fecha o modal no botão Close
  $(document).on('click', '[data-modal-close]', function (e) {
    e.preventDefault();
    $(this).closest('.c-modal').removeClass('is-active');
    $('#modal-form').remove();
  });

  // Fecha o modal clicando fora dele
  $(document).on('click', '.c-modal', function (e) {
    if (e.target.classList.contains('c-modal')) {
      $(this).removeClass('is-active');
    }
  });
};

export const closeModal = id => {
  document.querySelector(id).classList.remove('is-active');
};

export const openModal = id => {
  document.querySelector(id).classList.add('is-active');
};
